/**
 * Format a person's display name with honorific and generation code suffix.
 *
 * If preferredName is set it fully overrides the display (no wrapping).
 * Otherwise builds from firstName + lastName, framed by honorific/suffix.
 */
export function formatDisplayName(person: {
  honorific?: string | null;
  preferredName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  lastSurname?: string | null;
  generationCodeSuffix?: string | null;
}): string {
  if (person.preferredName) return person.preferredName;

  const parts: string[] = [];
  if (person.honorific) parts.push(person.honorific);
  parts.push(`${person.firstName || ''} ${person.lastName || person.lastSurname || ''}`.trim());
  if (person.generationCodeSuffix) parts.push(person.generationCodeSuffix);
  return parts.join(' ');
}
